<form class="g-3" name="VerificationForm" (ngSubmit)="Verification(VerificationForm)" #VerificationForm="ngForm"
    novalidate>
    <div class="modal-header">
        <h6 class="modal-title"><i class="bi bi-explicit"></i> {{this.Data.TravelType}} Expense</h6>
        <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-6">
                <label for="ExpenseDate" class="text-label-dark">Expense Date</label>
                <div class="input-group">
                    <input class="form-control" placeholder="DD MMM YYYY" name="ExpenseDate"
                        [(ngModel)]="Data.ExpenseDateObj" ngbDatepicker #ExpenseDate="ngbDatepicker" required readonly
                        (ngModelChange)="ClearData()" [minDate]="StartDate" [maxDate]="EndDate" />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ExpenseDate.toggle()"
                        type="button"></button>
                    <div class="invalid-feedback">
                        Please enter expense date
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <label for="CategoryVehiclesID" class="text-label-dark">Category</label>
                <ng-select name="CategoryVehiclesID" [items]="CategoryVehicles" [(ngModel)]="Data.CategoryVehiclesID"
                    bindLabel="CategoryVehicle" bindValue="ID" placeholder="Category" (change)="getClass()" required>
                </ng-select>
                <div class="invalid-feedback">
                    Please select category
                </div>
            </div>
            <!-- <div class="col-md-4">
                <label for="ESS_ExpenseClassDetailsId" class="text-label-dark">Class</label>
                <ng-select name="ESS_ExpenseClassDetailsId" [items]="Classs"
                    [(ngModel)]="Data.ESS_ExpenseClassDetailsId" bindLabel="ClassName"
                    bindValue="ESS_ExpenseClassDetailsId" placeholder="Class">
                </ng-select>
                <div class="invalid-feedback">
                    Please select class
                </div>
            </div> -->
            <div class="col-md-6" *ngIf="!this.Data.IsCategory">
                <label for="FromLocation" class="text-label-dark">From Location</label>
                <input type="text" class="form-control" placeholder="Ex. Mumbai" name="FromLocation"
                    [(ngModel)]="Data.FromLocation" #FromLocation="ngModel" required>
                <div class="invalid-feedback">
                    Please enter from location
                </div>
            </div>
            <div class="col-md-6" *ngIf="!this.Data.IsCategory">
                <label for="ToLocation" class="text-label-dark">To Location</label>
                <input type="text" class="form-control" placeholder="Ex. Delhi" name="ToLocation"
                    [(ngModel)]="Data.ToLocation" #ToLocation="ngModel" required>
                <div class="invalid-feedback">
                    Please enter to location
                </div>
            </div>
            <div class="col-md-4"
                *ngIf="this.Data.ESS_VehicleMasterId != null && this.Data.ESS_VehicleMasterId > 0 && !this.Data.AtActual">
                <label for="Kilometers" class="text-label-dark">KMs</label>
                <input type="text" class="form-control" placeholder="Ex. 15000" name="KMs" [(ngModel)]="Data.Kilometers"
                    #Kilometers="ngModel" maxlength="5" pattern="^[0-9.]*$"
                    (keypress)="common.NumberOnly($event,common.allowDot(Data.Kilometers))"
                    (keyup)="common.NumberOnly($event,common.allowDot(Data.Kilometers))" (change)="CalAmount()"
                    required>
                <div class="invalid-feedback">
                    Please enter KMs
                </div>
            </div>
            <div class="col-md-4"
                *ngIf="this.Data.ESS_VehicleMasterId != null && this.Data.ESS_VehicleMasterId > 0 && !this.Data.AtActual">
                <label for="Rate" class="text-label-dark">Rate</label>
                <input type="text" class="form-control" placeholder="Ex. 15000" name="Rate" [(ngModel)]="Data.Rate"
                    #Rate="ngModel" maxlength="5" pattern="^[0-9.]*$"
                    (keypress)="common.NumberOnly($event,common.allowDot(Data.Rate))"
                    (keyup)="common.NumberOnly($event,common.allowDot(Data.Rate))" required readonly>
                <div class="invalid-feedback">
                    Please enter rate
                </div>
            </div>
            <div class="col-md-4">
                <label for="ExpenseAmount" class="text-label-dark">Amount</label>
                <input type="text" class="form-control" placeholder="Ex. 15000" name="ExpenseAmount"
                    [(ngModel)]="Data.ExpenseAmount" #ExpenseAmount="ngModel" maxlength="5" pattern="^[0-9.]*$"
                    (keypress)="common.NumberOnly($event,common.allowDot(Data.ExpenseAmount))"
                    (keyup)="common.NumberOnly($event,common.allowDot(Data.ExpenseAmount))" required
                    [readOnly]="this.Data.ESS_VehicleMasterId != null && this.Data.ESS_VehicleMasterId > 0 && !this.Data.AtActual">
                <div class="invalid-feedback">
                    Please enter amount
                </div>
            </div>
            <div class="col-md-12">
                <label for="Merchant" class="text-label-dark">Merchant</label>
                <input type="text" class="form-control" placeholder="Ex. Maxus" name="Merchant"
                    [(ngModel)]="Data.Merchant" #Merchant="ngModel">
                <div class="invalid-feedback">
                    Please enter merchant
                </div>
            </div>
            <div class="col-md-12">
                <label for="Description" class="text-label-dark">Description</label>
                <textarea type="text" class="form-control" placeholder="Ex. 100 Main ST" id="Description"
                    name="Description" [(ngModel)]="Data.Description" #Description="ngModel" maxlength="200"
                    style="height: 70px;"></textarea>
                <div class="invalid-feedback">
                    Please enter description!
                </div>
            </div>

            <div class="col-md-12">
                <label for="Attachment" class="text-label-dark">Attachment</label><br />

                <Input id="Attachment" name="Attachment" accept=".jpeg,.jpg,.png,.pdf,.xlsx,.xls" type="file"
                    #Attachment matTooltip="Choose File" matTooltipClass="tooltip"
                    (change)="upload($event,common.CompanyParameterValue.ExpenseFolder)" style="display: none;"
                    [(ngModel)]="this.Data.Attachment" />

                <div class="ImageDiv-Form">
                    <div class="row">
                        <div class="col-12 mb-2">
                            <div class="upload-icon" *ngIf="this.Data.Attachment == null || this.Data.Attachment == ''"
                                (click)="Attachment.click()">
                                <i class="bi bi-upload"></i>
                                <br />
                                <label>Upload</label>
                            </div>
                            <div>
                                <img *ngIf="this.Data.Attachment != null && this.Data.Attachment != ''  && common.checkFileType(this.Data.Attachment) == 1"
                                    [src]="this.Data.AttachmentURL" class="registrationImage"
                                    style="max-height: 150px;width: -webkit-fill-available;border-radius:20px">

                                <iframe
                                    *ngIf="this.Data.Attachment != null && this.Data.Attachment != '' && common.checkFileType(this.Data.Attachment) == 2"
                                    [src]="this.sanitizer.bypassSecurityTrustResourceUrl(this.Data.AttachmentURL)"
                                    style="height: 150px;width: -webkit-fill-available;border-radius:20px"
                                    class="registrationImage"></iframe>

                                <img *ngIf="this.Data.Attachment != null && this.Data.Attachment != '' && common.checkFileType(this.Data.Attachment) == 3"
                                    src="./../../../../assets/xls.png"
                                    style="height: 150px;width: -webkit-fill-available;border-radius:20px" class="registrationImage" />
                            </div>
                        </div>
                        <div class="col-6">
                            <a class="btn btn-outline-secondary btn-sm" [href]="this.Data.AttachmentURL"
                                *ngIf="this.Data.Attachment" target="_blank"><i class="bi bi-paperclip"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'View':'Loading...'}}</a>
                        </div>
                        <div class="col-6">
                            <button type="button" class="btn btn-outline-danger btn-sm mx-2"
                                (click)="RemoveAttachment()" *ngIf="this.Data.Attachment" target="_blank"><i
                                    class="bi bi-paperclip" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Remove':'Loading...'}}</button>
                        </div>
                    </div>
                </div>

                <!-- <a class="btn btn-outline-secondary btn-sm" [href]="this.Data.AttachmentURL"
                    *ngIf="this.Data.Attachment" target="_blank"><i class="bi bi-paperclip" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'View':'Loading...'}}</a>

                <button type="button" class="btn btn-outline-danger btn-sm mx-2" (click)="RemoveAttachment()"
                    *ngIf="this.Data.Attachment" target="_blank"><i class="bi bi-paperclip" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Remove':'Loading...'}}</button> -->
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary" [disabled]="isDisabled">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
            {{!isDisabled?'Submit':'Loading...'}}</button>
        <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled" (click)="close()"><i
                class="bi bi-x" *ngIf="!isDisabled"></i>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
            {{!isDisabled?'Cancel':'Loading...'}}</button>
    </div>
</form>